<div class="container-fluid" [ngClass]="!theme ? 'dark-theme' : ''">
    <ng-container *ngIf="isAuthorized;then authorized;else authorization"></ng-container>
    <ng-template #authorization>
        <div class="row">
            <div class="col-sm-12 p-0">
                <div class="card mb-0 border-0">
                    <div class="card-body p-0">
                        <div class="profile-bg  position-relative">
                            <div class="bg-overlay p-48">
                                <h1 class="txt-blue txt-heading mb-2">Integrations</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 d-flex justify-content-center">
            <div class="col-6 d-block d-xxl-flex justify-content-center align-items-center mt-5">
                <div class="col-12 col-xxl-8 profile-wrapper m-2">
                    <div class="card profile-card" style="height: 14rem">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center col-6">
                                    <i class="bi bi-wordpress"
                                        style="font-size: 40px;padding-right: 10px;color: #00749c;"></i>
                                    <h2 class="txt-black p-0 m-0">Wordpress</h2>
                                </div>
                                <div class="col-6 d-flex align-items-center justify-content-end">
                                    <div><button class="btn btn-success" *ngIf="intregtedAccount.length != 0"
                                            (click)="open(content)">Connected</button>
                                    </div>
                                    <div><button class="btn btn-primary" *ngIf="intregtedAccount.length == 0"
                                            (click)="open(content)">Connect</button>
                                    </div>
                                </div>
                            </div>
                            <p class="px-2 mt-4 text-secondary fs-6" style="padding: 20px;">
                                Integrate your WordPress websites with Strell and effortlessly publish articles with just a
                                single click.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xxl-8 profile-wrapper m-2">
                    <div class="card profile-card" style="height: 14rem;">
                        <div class="card-body">
                            <div class="d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center">
                                    <img src="../../../assets/images/gsc.png" class="me-3" height="40" width="40" alt="">
                                    <!-- <i class="bi bi-google" style="font-size: 60px;padding-right: 10px;color: #00749c;"></i> -->
                                    <h2 class="txt-black p-0 m-0">Google Search Console</h2>
                                </div>
                                <div class="">
                                    <div>
                                    </div>
                                    <div><button class="btn btn-primary" *ngIf="accessToken ==''" (click)="authorize()">Connect</button>
                                        <button class="btn btn-success" *ngIf="accessToken !==''"(click)="navigateToGsc()">Connected</button>
                                </div>
                                </div>
                            </div>
                            <!-- <p class="px-2 my-3 text-secondary fs-6">
                            Coming Soon
                        </p> -->
                        <p class="px-2 mt-4 text-secondary fs-6" style="padding: 20px;">
                            Integrate your Google search console with Strell and effortlessly monitor your sites traffic.
                        </p>
                            <!-- <div class="d-flex align-items-center justify-content-center mt-3">
                                
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #content let-modal>
            <div class="modal-header">
                <img src="../../../assets/images/strellnew-dark-single.png" height="40" width="40" alt="">
                <i class="bi bi-link ms-3 me-3 fs-3"></i>
                <i class="bi bi-wordpress" style="font-size: 40px;padding-right: 10px;color: #00749c;"></i>
                <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12">
                        <div style="padding: 5px;margin: 5px;">
                            <div>
                                <!-- <p
                                            style="border: 1px solid #000;padding: 6px;background: aliceblue;border-radius: 5px;">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                                                aria-hidden="true" style="width:20px" class="h-5 w-5 text-blue-400">
                                                <path fill-rule="evenodd"
                                                    d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 01.67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 11-.671-1.34l.041-.022zM12 9a.75.75 0 100-1.5.75.75 0 000 1.5z"
                                                    clip-rule="evenodd"></path>
                                            </svg>
                                            You must link a user that has an Author, Editor, or
                                            Admin role. We recommend using the Editor or Admin
                                            role because some functionality will not work
                                            perfectly with an Author. Also, you must use an
                                            Application Password, not a regular password. You
                                            can easily create an Application Password on the
                                            Profile page or when editing a User in the WordPress
                                            Admin (view video here). For the domain you must
                                            only include the domain name such as "google.com"
                                            and not "https://google.com/"
                                        </p> -->
                                <div class="">
                                    <div class="card">
                                        <div class="card-header">
                                            <label for="website" class><strong>WordPress
                                                    Site Domain</strong></label>
                                        </div>
                                        <div class="card-body">
                                            <div class="mt-2 d-flex">
                                                <span style="background: #dde0e3;padding: 15px"
                                                    class="domain-div">https://</span>
                                                <input class="form-control url-div" type="text" [(ngModel)]="wbSite"
                                                    placeholder="google.com">
                                            </div>
                                            <p class="mt-3 text-sm text-gray-400" style="color: #959191;font-size: 12px;">
                                                Make
                                                sure
                                                your site does not block the built-in
                                                WordPress REST API. At a minimum, the
                                                "/wp-json/wp/v2/posts" endpoint must be
                                                accessible.</p>
                                        </div>
    
                                    </div>
                                    <div class="mt-4 card">
                                        <div class="card-header">
                                            <label for="username"><strong>WordPress
                                                    Username</strong></label>
                                        </div>
                                        <div class="card-body">
                                            <div class="mt-2">
                                                <input style="padding: 14px 12px;" class="form-control input" type="text"
                                                    placeholder="superuser" [(ngModel)]="wordPressUserName">
                                            </div>
                                            <p class="mt-3 text-sm text-gray-400" style="color: #959191;font-size: 12px;">
                                                You
                                                must
                                                use the username of a WordPress user with
                                                Author, Editor, or Admin roles. Do not use
                                                the name of the Application Password. We
                                                recommend using the Editor or Admin role
                                                because some functionality will not work
                                                perfectly with an Author.</p>
                                        </div>
                                    </div>
                                    <div class="mt-4 card">
                                        <div class="card-header">
                                            <label><strong>WordPress
                                                    Application Password</strong></label>
                                        </div>
                                        <div class="card-body">
                                            <div class="mt-2">
                                                <input style="padding: 14px 12px;" class="form-control input"
                                                    [(ngModel)]="password2" placeholder="ABCD EFGH IJKL MNOP"
                                                    type="password">
                                            </div>
                                            <p class="mt-3 text-sm text-gray-400" style="color: #959191;font-size: 12px;">
                                                This
                                                must
                                                be an Application Password - not the regular
                                                password that is used to login! It looks
                                                like this: "E66J cCGF vxcM eraH PtLD 66X1".
                                                See the message above for more information
                                                on how to create one.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div><br><br>
                        <div *ngIf="intregtedAccount.length != 0">
                            <div class="mb-4 d-flex justify-content-between input" *ngFor="let i of intregtedAccount"
                                style="align-items: center;background-color: #ece6e6;margin: 0px 15px;padding: 7px;">
                                <span>{{i.webSite}}</span>
                                <span>{{i.userName}}</span>
                                <button class="btn btn-danger" (click)="deleteWordPressAccount(i.id)">Disconnect</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="">
                    <button class="btn btn-primary ml-4" id="confirmBtn"
                        [disabled]="wbSite == '' || wordPressUserName == '' || password2 == ''"
                        (click)="addAccount();">Confirm</button>
                </div>
            </div>
    
    
        </ng-template>
        <ng-template #customLoadingTemplate>
            <div class="custom-class vh-100">
            </div>
        </ng-template>
        <ngx-loading [show]="!!isLoading" [config]="{ backdropBorderRadius: '3px'}"
        [template]="customLoadingTemplate"></ngx-loading>
    </ng-template>
    <ng-template #authorized>
        <div class="d-flex justify-content-center align-items-center vh-100">
            <div class="text-center">
                <img src="../../../assets/icons/google.svg" height="50" width="50" alt="">
                <h3 class="fw-bold">Synchronize your Strell account with Google Search Console</h3>
                <p>Track organic growth and identify opportunities</p>
                <button class="btn btn-outline-primary" (click)="authorizeGsc()">Sync to Google Search Console</button>
                <p class="mt-2"><a href="" (click)="isAuthorized = false">Back to Integrations</a></p>
            </div>
        </div>
    </ng-template>
   
</div>